"use client";

import * as React from "react";
import { Slider as SliderPrimitive } from "@base-ui/react/slider";

import { cn } from "@/lib/shared/utils";

function Slider({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
  const rawValue = value ?? defaultValue;
  const _values = rawValue === undefined ? [] : Array.isArray(rawValue) ? rawValue : [rawValue];

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      className={cn(
        "relative flex w-full touch-none items-center select-none data-disabled:opacity-50",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Control className="relative h-1.5 w-full grow">
        <SliderPrimitive.Track
          data-slot="slider-track"
          className="bg-muted relative h-full w-full overflow-hidden rounded-full data-[orientation=vertical]:w-1.5"
        >
          <SliderPrimitive.Indicator
            data-slot="slider-range"
            className="bg-foreground absolute h-full data-[orientation=vertical]:w-full"
          />
        </SliderPrimitive.Track>
        {Array.isArray(_values) &&
          _values.map((_, index) => (
            <SliderPrimitive.Thumb
              data-slot="slider-thumb"
              key={index}
              index={index}
              className="border-foreground bg-background ring-muted focus-visible:ring-ring/50 block size-5 shrink-0 rounded-full border-2 shadow-md transition-transform duration-150 hover:scale-110 focus-visible:ring-4 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"
            />
          ))}
      </SliderPrimitive.Control>
    </SliderPrimitive.Root>
  );
}

export { Slider };
